<template>
  <svg stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
</template>
